import React, { useState, useEffect } from 'react';

const GuestDemo = ({ theme }) => {
    const [step, setStep] = useState(0);

    const scenario = [
        { type: 'guest', text: "What's the Wi-Fi password?" },
        { type: 'kypser', text: "The network is 'GrandSuites_Guest' and the password is 'Horizon2025'. Enjoy your stay!" },
        { type: 'guest', text: "And check out time?" },
        { type: 'kypser', text: "Check-out is by 11:00 AM. If you need a late departure, I can check availability for you." },
        { type: 'guest', text: "Yes please, 1 hour more." },
        { type: 'kypser', text: "Late check-out confirmed until 12:00 PM. No extra charge. Your digital key is updated." }
    ];

    useEffect(() => {
        const timer = setInterval(() => {
            setStep(prev => (prev < scenario.length ? prev + 1 : prev));
        }, 2800);
        return () => clearInterval(timer);
    }, [scenario.length]);

    return (
        <div className="flex flex-col items-center justify-center py-20">
            <div className={`relative mx-auto w-[300px] h-[600px] rounded-[55px] border-[12px] overflow-hidden transition-all duration-500 shadow-2xl ${theme === 'dark' ? 'bg-black border-zinc-900 shadow-white/5' : 'bg-zinc-100 border-white shadow-black/5'}`}>
                <div className={`absolute top-0 inset-x-0 h-8 z-30 flex items-center justify-center ${theme === 'dark' ? 'bg-black' : 'bg-zinc-100'}`}>
                    <div className={`w-12 h-4 rounded-full transition-colors ${theme === 'dark' ? 'bg-zinc-900' : 'bg-white'}`}></div>
                </div>

                <div className={`h-full flex flex-col p-6 pt-12 overflow-y-auto transition-colors duration-500 ${theme === 'dark' ? 'bg-black' : 'bg-white'}`}>
                    <div className="mb-10 text-center">
                        <h4 className="text-sm font-bold tracking-[0.2em] uppercase text-zinc-500 mb-1">Your Concierge</h4>
                        <div className={`text-xl font-bold transition-colors ${theme === 'dark' ? 'text-white' : 'text-black'}`}>Room 304</div>
                    </div>

                    <div className="space-y-6">
                        {scenario.slice(0, step).map((msg, idx) => (
                            <div
                                key={idx}
                                className={`flex flex-col ${msg.type === 'guest' ? 'items-end' : 'items-start'} animate-slide-up`}
                            >
                                <div
                                    className={`max-w-[90%] px-4 py-3 rounded-2xl text-xs font-medium leading-relaxed shadow-sm transition-colors duration-500 ${msg.type === 'guest'
                                            ? (theme === 'dark' ? 'bg-zinc-800 text-white rounded-tr-none' : 'bg-zinc-100 text-black rounded-tr-none')
                                            : (theme === 'dark' ? 'bg-white text-black rounded-tl-none' : 'bg-black text-white rounded-tl-none')
                                        }`}
                                >
                                    {msg.text}
                                </div>
                                <div className="text-[8px] uppercase tracking-widest font-bold text-zinc-600 mt-1">
                                    {msg.type === 'guest' ? 'Sent' : 'Kypser AI'}
                                </div>
                            </div>
                        ))}
                        {step < scenario.length && (
                            <div className="flex justify-start">
                                <div className="flex gap-1.5 p-2 rounded-full">
                                    <span className={`w-1 h-1 rounded-full animate-bounce ${theme === 'dark' ? 'bg-zinc-500' : 'bg-zinc-300'}`}></span>
                                    <span className={`w-1 h-1 rounded-full animate-bounce [animation-delay:0.2s] ${theme === 'dark' ? 'bg-zinc-500' : 'bg-zinc-300'}`}></span>
                                    <span className={`w-1 h-1 rounded-full animate-bounce [animation-delay:0.4s] ${theme === 'dark' ? 'bg-zinc-500' : 'bg-zinc-300'}`}></span>
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                <div className={`absolute bottom-6 inset-x-6 flex items-center rounded-full px-4 py-3 border transition-all duration-500 ${theme === 'dark' ? 'bg-zinc-900/50 backdrop-blur border-zinc-800/50' : 'bg-zinc-50/80 backdrop-blur border-zinc-200'}`}>
                    <div className="text-[10px] text-zinc-400 font-bold uppercase tracking-widest">Type message...</div>
                </div>
            </div>

            <div className="mt-12 text-center max-w-sm px-6">
                <h4 className={`text-xl font-bold mb-4 transition-colors ${theme === 'dark' ? 'text-white' : 'text-black'}`}>Invisible interaction.</h4>
                <p className="text-zinc-500 text-sm leading-relaxed">
                    Guests interact with a premium, focused interface that feels like an extension of your property's service.
                </p>
            </div>
        </div>
    );
};

export default GuestDemo;

